module.exports = __webpack_public_path__ + "img/icon-remove-image.7e517610.svg";